import React from 'react';
import PropTypes from 'prop-types';
import createClass from 'create-react-class';
import { forEach, toLower } from 'lodash';
import { RCOMBRIDGE_getClientSiteURLParams, getQueryStringParams } from '../../../../jsxctl/utilctl';
import { BuyTicketOnePagerWidget } from './buyticketonepagerwidget';

const lowerToReactCasing = {
    "eventdateid": "eventDateID",
    "programid":"programID",
    "rst-prv": "rstprv",
    "rstprv": "rstprv",
    "eventid": "eventID",
    "preferredselectedeventdateid": "preferredSelectedEventDateID",
    "packageid": "packageID",
    "ispackage": "isPackage",
    "lang": "lang",
    "hidebestticketselection":"hideBestTicketSelection"
};

const integerQueryParams = ["eventDateID", "eventID", "preferredSelectedEventDateID", "packageID"];

export const WidgetAutoLoader = createClass({
    displayName: "WidgetAutoLoader",
    
    propTypes: {
        integ: PropTypes.string,
        continueShoppingUrl: PropTypes.string.isRequired,
        onContentChange: PropTypes.func,
        hasShopConfig: PropTypes.bool,
    },

    getDefaultProps() {
        return { cookiesverified: false };
    },
    
    getInitialState() {
        return {
            props: null
        };
    },

    componentDidMount() {
        this.setPropsByCLientUrlParams();
    },

    getUrlParams(params) {
        let props = {};
        forEach(params, (value, key) => {
            const keyToLookFor = lowerToReactCasing[toLower(key)];
            if(keyToLookFor != undefined) {
                if (integerQueryParams.includes(keyToLookFor)) {
                    value = parseInt(value);
                }
            }
            props[keyToLookFor] = value;
        });
        
        this.setState({ props: props });
    },
    
    setPropsByCLientUrlParams() {
        if(!this.props.hasShopConfig)
            RCOMBRIDGE_getClientSiteURLParams(this.getUrlParams, true);
        else {
            let params = getQueryStringParams(window.location.href || document.location.href, true);
            this.getUrlParams(params);
        }
    },

    render() {
        let content = null;
        if(this.state.props) {
            content = <BuyTicketOnePagerWidget {...this.state.props}
                                                        integ={this.props.integ}
                                                        cookiesverified={this.props.cookiesverified}
                                                        continueShoppingUrl={this.props.continueShoppingUrl}
                                                        onContentChange={this.props.onContentChange} />;
            
        }
        
        return <div>{content}</div>;
    }
});